import {
  ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS,
  ENTREPRENEURSHIP_SPECIFIC_QUESTION_KEYS,
} from './questionConstants';
import {
  getUserResponse,
  getQuestionByKey,
  didUserSelectOptionWithAnswerByKey,
  didUserSelectAnyOptionWithAnswersByKey,
} from './scoreHelpers';
import { CareerUserResponseSet, CareerQuestion } from '../models/models';

export function determineIfEntrepreneurshipRecommended(
  responseSet: CareerUserResponseSet,
  questions: CareerQuestion[],
): boolean {
  if (!responseSet || !questions) {
    return false;
  }

  const cell_L6 = determineIfEntrepreneurshipRecommended_Cell_L6(responseSet, questions);
  const cell_M6 = determineIfEntrepreneurshipRecommended_Cell_M6(responseSet, questions);

  return cell_L6 || cell_M6;
}

function determineIfEntrepreneurshipRecommended_Cell_L6(
  responseSet: CareerUserResponseSet,
  questions: CareerQuestion[],
): boolean {
  // Find the "Building Wealth" question
  const wealthQuestion = getQuestionByKey(
    questions,
    ENTREPRENEURSHIP_SPECIFIC_QUESTION_KEYS.BUILDING_WEALTH,
  );

  // Find the "Activities You Don't Like" question
  const activitiesQuestion = getQuestionByKey(
    questions,
    ENTREPRENEURSHIP_SPECIFIC_QUESTION_KEYS.ACTIVITIES_YOU_DONT_LIKE,
  );

  if (!wealthQuestion || !activitiesQuestion) {
    return false;
  }

  const wealthResponse = getUserResponse(responseSet, wealthQuestion.id);
  const activitiesResponse = getUserResponse(responseSet, activitiesQuestion.id);

  if (!wealthResponse || !activitiesResponse) {
    return false;
  }

  // is "Very Important" selected for wealth
  const wealthIsVeryImportant = didUserSelectOptionWithAnswerByKey({
    response: wealthResponse,
    question: wealthQuestion,
    answerText: ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D28,
  });

  // does user dislike any of the specified activities
  const dislikedActivities = [
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D67,
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D72,
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D74,
  ];
  const dislikesAny = didUserSelectAnyOptionWithAnswersByKey({
    response: activitiesResponse,
    question: activitiesQuestion,
    answerTexts: dislikedActivities,
  });

  // Return true if wealth is very important and the user doesn't dislike the activities
  return wealthIsVeryImportant && !dislikesAny;
}

function determineIfEntrepreneurshipRecommended_Cell_M6(
  responseSet: CareerUserResponseSet,
  questions: CareerQuestion[],
): boolean {
  // Find the "Activities You Enjoy" question
  const activitiesEnjoyQuestion = questions.find(
    (question) =>
      question.calculator_key === ENTREPRENEURSHIP_SPECIFIC_QUESTION_KEYS.ACTIVITIES_YOU_ENJOY,
  );

  if (!activitiesEnjoyQuestion) {
    return false;
  }

  // Get user response
  const enjoyActivitiesResponse = getUserResponse(responseSet, activitiesEnjoyQuestion.id);

  if (!enjoyActivitiesResponse) {
    return false;
  }

  // Check if the user enjoys any of the specified activities
  const enjoyedActivities = [
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D55,
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D60,
    ENTREPRENEURSHIP_SPECIFIC_CELL_KEYS.cell_D62,
  ];

  const enjoysAny = didUserSelectAnyOptionWithAnswersByKey({
    response: enjoyActivitiesResponse,
    question: activitiesEnjoyQuestion,
    answerTexts: enjoyedActivities,
  });

  // Return true if the user enjoys at least one of the activities
  return enjoysAny;
}
